import * as React from "react";

export const withClassName = (str: string) => ({
  children,
  className = "",
}: any) => <div className={className + " " + str}>{children}</div>;
